/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
} from './PaymentMethod';

/**
 * 
 * @export
 * @interface DeleteUserPaymentMethod200ResponseAllOfData
 */
export interface DeleteUserPaymentMethod200ResponseAllOfData {
    /**
     * 
     * @type {PaymentMethod}
     * @memberof DeleteUserPaymentMethod200ResponseAllOfData
     */
    defaultPaymentMethod?: PaymentMethod;
}

/**
 * Check if a given object implements the DeleteUserPaymentMethod200ResponseAllOfData interface.
 */
export function instanceOfDeleteUserPaymentMethod200ResponseAllOfData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteUserPaymentMethod200ResponseAllOfDataFromJSON(json: any): DeleteUserPaymentMethod200ResponseAllOfData {
    return DeleteUserPaymentMethod200ResponseAllOfDataFromJSONTyped(json, false);
}

export function DeleteUserPaymentMethod200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteUserPaymentMethod200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'defaultPaymentMethod': !exists(json, 'default_payment_method') ? undefined : PaymentMethodFromJSON(json['default_payment_method']),
    };
}

export function DeleteUserPaymentMethod200ResponseAllOfDataToJSON(value?: DeleteUserPaymentMethod200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'default_payment_method': PaymentMethodToJSON(value.defaultPaymentMethod),
    };
}

